module.exports = __webpack_public_path__ + "static/shc2-09789a878555bf467d68ca5a99b4221b.png";